const pad = (num: number) => `${num}`.padStart(2, '0');

export const toLocalDateTimeInput = (value?: string | null): string => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const local = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  return local.toISOString().slice(0, 16);
};

export const fromLocalDateTimeInput = (value: string): string | null => {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return (
    `${date.getUTCFullYear()}-${pad(date.getUTCMonth() + 1)}-${pad(date.getUTCDate())}` +
    ` ${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}:${pad(date.getUTCSeconds())}`
  );
};

export const formatDuration = (seconds: number) => {
  if (!seconds) return '—';
  const mins = Math.ceil(seconds / 60);
  if (mins < 1) return '< 1 мин.';
  const hours = Math.floor(mins / 60);
  if (hours > 0) {
    const remMins = mins % 60;
    return remMins > 0 ? `${hours} ч. ${remMins} мин.` : `${hours} ч.`;
  }
  return `${mins} мин.`;
};
